import Vue from 'vue'
import router from '@/router/index'

const httpCodes = {
  ok: 200,
  created: 201,
  badRequest: 400,
  unauthorized: 401,
  permissionDenied: 403,
  notFound: 404,
  notAcceptable: 406,
  afterDelete: 409,
  validationError: 422,
  serverError: 500
}

function mayNotifySuccessResponse (response) {
  let hasNotification = response?.config?.hasNotification
  // Disable notification for API call
  if (hasNotification === false) return

  const notifySettings = {
    type: 'success',
    title: 'Success',
    text: response?.data?.message,
    data: { closeHidden: false },
    duration: 5000
  }

  if (response.status === httpCodes.ok || response.status === httpCodes.created) {
    if (notifySettings.text) hasNotification = true
    hasNotification && Vue.notify(notifySettings)
  }
}

function mayNotifyErrorResponse (error) {
  let hasNotification = error?.config?.hasNotification
  const hasDefaultRedirect = error?.config?.hasDefaultRedirect

  // Disable notification for API call
  if (hasNotification === false) return

  const notifySettings = {
    type: 'warn',
    title: 'Warning',
    text: error?.response?.data?.message,
    data: { closeHidden: false, refreshShown: error?.response?.data?.refreshShown },
    duration: 5000
  }
  const method = error?.config?.method

  switch (error?.response?.status) {
    case httpCodes.badRequest:
      notifySettings.title = 'Bad request'
      notifySettings.duration = -1
      hasNotification = true
      break
    case httpCodes.unauthorized:
      if (process.env.VUE_APP_IS_PUBLIC) {
        // go to /login on the public site
        router.replace({ name: 'PublicLogin' })
      } else {
        window.location = '/c/etc/default.php?referer=' + encodeURIComponent(window.location.href)
      }
      break
    case httpCodes.permissionDenied:
      if (!error?.response?.data?.redirect && notifySettings.text) {
        notifySettings.title = 'Permission denied'
        hasNotification = true
      } else {
        hasDefaultRedirect && router.replace({ name: 'AccessDenied', params: { text: notifySettings?.text } })
      }
      break
    case httpCodes.notFound:
      switch (method) {
        case 'get':
          router.replace({ name: 'PageNotFound' })
          break
        case 'post':
          notifySettings.text = 'Can’t create entity, please '
          notifySettings.duration = -1
          notifySettings.data = { closeHidden: true, refreshShown: true }
          hasNotification = true
          break
        case 'put':
          notifySettings.text = 'Entity to update not found, please '
          notifySettings.duration = -1
          notifySettings.data = { closeHidden: true, refreshShown: true }
          hasNotification = true
          break
        case 'delete':
          notifySettings.text = 'Entity to delete not found, please '
          notifySettings.duration = -1
          notifySettings.data = { closeHidden: true, refreshShown: true }
          hasNotification = true
          break
      }
      break
    case httpCodes.notAcceptable:
      notifySettings.type = 'error'
      notifySettings.title = 'Invalid'
      notifySettings.duration = -1
      hasNotification = true
      Vue.config.errorHandler({ ...error, ...{ shouldSendAirbrake: true } })
      break
    case httpCodes.afterDelete:
      notifySettings.type = 'info'
      notifySettings.title = error?.response?.data?.errors?.header || 'Invalid'
      notifySettings.data = {
        messages: error?.response?.data?.errors?.info?.map(error => {
          return {
            text: error.errorText,
            linkTo: error?.link?.url,
            linkText: error?.link?.text
          }
        })
      }
      notifySettings.duration = -1
      hasNotification = true
      break
    case httpCodes.validationError:
      break
    case httpCodes.serverError:
      Vue.config.errorHandler({ ...error, ...{ shouldSendAirbrake: true } })
      break
  }

  // Bad Request
  if (hasNotification) {
    Vue.notify(notifySettings)
  }
}

export { mayNotifySuccessResponse, mayNotifyErrorResponse }
